module.exports = __webpack_public_path__ + "img/park-ar.bede0b07.jpg";